module.exports = __webpack_public_path__ + "img/green.c49f15a5.svg";